import React from "react";
import { Globe2 } from "lucide-react";

const WhatsNew = () => {
  return (
    <section className="section bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="text-center mb-14">
          <p className="tracking-[0.3em] text-coral-300 font-semibold text-sm">WHAT&apos;S NEW</p>
          <h2 className="font-serif text-navy-700 text-4xl md:text-5xl mt-3">Fresh updates &amp; stories</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center max-w-6xl mx-auto">
          <div className="order-2 md:order-1">
            <div className="rounded-3xl overflow-hidden aspect-square bg-gradient-to-br from-coral-100 to-cream-200 relative flex items-center justify-center">
              <div className="absolute inset-6 rounded-2xl bg-white/40 backdrop-blur-sm border border-white/60 flex items-center justify-center">
                <div className="text-center px-6">
                  <Globe2 className="w-16 h-16 mx-auto text-coral-300 mb-3" />
                  <div className="font-serif italic text-3xl text-navy-700">10 languages</div>
                  <div className="text-sm text-navy-700/70 mt-2">Now multi-lingual</div>
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <span className="inline-block text-coral-300 bg-coral-100/70 px-3 py-1 rounded text-xs font-semibold tracking-wider uppercase">New Platform Feature</span>
            <h3 className="font-serif italic text-navy-700 text-4xl md:text-5xl mt-5 leading-tight">Hola, Bonjour, Ciao, Hallo!</h3>
            <p className="text-navy-700 text-xl mt-5">
              GALERIECOP is now a <u className="decoration-coral-300 underline-offset-4">multi-lingual</u> platform. Available in Spanish, French, Italian, German + 5 more languages!
            </p>
            <p className="text-navy-700/70 mt-4 leading-relaxed">
              To give all our hosts and guests the best experience, the host and guest platform is now available in 10 languages — covering more of your guests, wherever they&apos;re joining from.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsNew;
